// @flow

import { capitalize } from './string'

/**
 * Creates a function that will post to a given Webkit message handler.
 */
export const mkWebkitMsgPoster = (handlerName: string) => (msg: string) => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    handlerName in window.webkit.messageHandlers
  ) {
    window.webkit.messageHandlers[handlerName].postMessage(msg)
  }
}

/**
 * Creates a function that will post to a given Android message handler.
 */
export const mkAndroidMsgPoster = (handlerName: string) => (msg: string) => {
  const interfaceName = `android${capitalize(handlerName)}`
  if (
    interfaceName in window &&
    typeof window[interfaceName].receiveMessageFromJS === 'function'
  ) {
    window[interfaceName].receiveMessageFromJS(msg)
  }
}
